<template>
  <div class="content Tabs">

    <b-tabs card v-model="tabIndex">

      <b-tab :title="lang.tab_Import" :title-link-class="textColors" :title-item-class="textColors"
        :active="tabIndex == 0">
        <!-- <b-container class="bv-example-row">



          <b-form class="file-form">
            {{lang.label_file}}:
            <br><br>
            <b-row>

              <b-col cols="7">
                <b-form-file v-model="file" :state="Boolean(file)" :placeholder=lang.placeholder_file
                  drop-placeholder="Drop file here..." class="import-file" accept=".csv" size="sm"
                  ></b-form-file>
              </b-col>
              <b-col cols="5">

              </b-col>

            </b-row>
            <br>


          </b-form>
          <hr v-if="isCsv">
          <span v-if="isCsv">


            <ImportLibrariesTableComponent v-if="isCsv" :lang="lang.ImportLibraries" :data="libraries"></ImportLibrariesTableComponent>


            </span>
        </b-container> -->
      </b-tab>


      <b-tab v-if="currentUser.role=='Admin'" :title="lang.tab_ImportHistory" :title-link-class="textColors"
        :title-item-class="textColors" :active="tabIndex == 3">
        <b-container class="bv-example-row">

          <ImportHistoryComponent :lang="lang.TableImportHistory"></ImportHistoryComponent>
        </b-container>
      </b-tab>
    </b-tabs>




  </div>

</template>
<script>
import { mapGetters } from 'vuex'


import ImportLibrariesTableComponent from '@/components/shared/ImportLibrariesTableComponent'
import ImportHistoryComponent from '@/components/shared/ImportHistoryComponent'


export default {
  name: "Content",
  components: {

    ImportLibrariesTableComponent,
    ImportHistoryComponent,


  },
  props:{
    lang: Object,

  },
  data () {
    return {
      file: null,
      isCsv: false,
      isTable: false,
      category: "",
      tabIndex: 0,
      tableFields: ['line', 'values', 'error'],
      libraries: null
    }
  },
  computed: {
    ...mapGetters({
      //selectedTreeItemObject: 'selectedTreeItemObject',
      //notImportedParts: 'notImportedParts'

    }),
    currentUser(){
      return this.$store.getters.currentUser;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }

    }
  },
  created () {
    this.getTabIndex();

    this.$store.commit("SETCSVIMPORT", [])

  },


  watch: {
    file: function () {
      if (this.file != null) {
        this.uploadFile();
      }

    },


    tabIndex: function (newVal) {

      let obj = {};
      obj[this.$route.path + "__middle"] = newVal;

      this.$store.commit("SETTABDATA", obj);

      //####################

      this.file = null;
      this.isCsv = false;

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_resetMapField");

      this.$parent.$parent.$parent.switchButtons(newVal);



      // const objActive = {
      //   allActive: false,
      //   type: "Electric"
      // }

      // this.$store.dispatch(this.$store.getters.sectionPrefix + "_setAllActiveImportedParts", objActive);
    },

    notImportedParts: function(newVal){

      if (newVal.length == 0){
        this.isTable = false;

      }else{
        this.isCsv = false;
        this.isTable = true;

      }
    },

  },
  methods: {
    getTabIndex() {


      if (this.$store.getters.tabData[this.$route.path + "__middle"] != undefined) {
        this.tabIndex = this.$store.getters.tabData[this.$route.path + "__middle"];
      } else {
        this.tabIndex = 0;
      }

    },
    uploadFile(){
      this.$store.dispatch("showLoader", { visible: true, text: "Uploading..." });

      let _vue = this;
      this.libraries = null;

      let obj = {
        file: {file: this.file},

      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_importLibrariesCSVList", obj)
      .then(function(result) {

        console.log(result,result.status)
        _vue.$store.dispatch("showLoader", { visible: false });

        if (result.status == "OK") {
          if (result.data != null) {


            console.log(result.data)
            _vue.libraries = result.data
            //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setPreviewParts", result.data.Data);
            //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setImportedFileId", result.data.fileId);
            _vue.isCsv = true;

            const obj = {
              text: _vue.lang.alert_success_importCSV,
              time: 10,
              type: "success"
            }
            _vue.$store.dispatch("displayFooterAlert", obj);
          } else {
            const obj = {
              text: _vue.lang.alert_error_importCSV + ": " + result.message,
              time: 15,
              type: "danger"
            }


            _vue.$store.dispatch("displayFooterAlert", obj);
          }
        } else {
          const obj = {
            text: _vue.lang.alert_error_importCSV + ": " + result.message,
            time: 15,
            type: "danger"
          }


          _vue.$store.dispatch("displayFooterAlert", obj);
        }




      })

    },


  },

}
</script>

<style lang="scss">

  .Tabs{
    .bv-example-row-max{
      max-width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }

    .file-form{
      width: 80%;
    }

    .upload-form-button{

      margin-left: 10px;
      margin-top: 2px;
    }
    .spinner-import{
      margin-left: 20px;
    }
    .input-category{
      width: 300px;

    }
    .select-type{
      max-width: 200px;
      height: 26px;
      font-size: 0.75rem;
      padding-top: 2px;
    }
    .label-type{
      text-align: right;
    }
    .select-delimiter{
      width: 70px;
    }
    .import-file{

      //width: 300px;
    }
  }




</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryImport/Middle/Content/Content.vue